import { render, staticRenderFns } from "./TaskLev.vue?vue&type=template&id=f30e271a&scoped=true&"
import script from "./TaskLev.vue?vue&type=script&lang=js&"
export * from "./TaskLev.vue?vue&type=script&lang=js&"
import style0 from "./TaskLev.vue?vue&type=style&index=0&id=f30e271a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30e271a",
  null
  
)

export default component.exports